$(window).on('load', function() {
  setTimeout(function() {
    var $anchorTag = $('a');

    $anchorTag.each(function(index, elem) {
      var targetAttribute = $(elem).attr('target');

      if (targetAttribute && targetAttribute === '_blank') {
        var existingRelValue = $(elem).attr('rel'),
            relValue = ' noopener noreferrer nofollow';

        if (existingRelValue && existingRelValue !== relValue) {
          $(elem).attr('rel', existingRelValue + relValue);
        } else {
          $(elem).attr('rel', relValue);
        }
      }
    });
  }, 1000);
});
